import { render } from "./PricingSettings.vue?vue&type=template&id=74fe778c"
import script from "./PricingSettings.vue?vue&type=script&lang=js"
export * from "./PricingSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__